import pt from "../languages/pt";
import en from "../languages/en";
import es from "../languages/es";
const messages = {
  'en': en,
  'es': es,
  'pt': pt
};
export default messages;